import { from } from 'rxjs/observable/from';

export { TabsPage } from './tabs/tabs';
export { HomePage } from './home/page';
export { PortalPage } from './portal/page';
export { LoginPage } from './login/page';
export { ProfilPage } from './profil/page';
export { EditPegawai } from './profil/edit_profil/page';
export { DetailNewsPage } from './detailnews/page';
export { Aproval } from './aproval/page';
export { AprovalDetail } from './aproval/aproval_detail/page';
export { DetailPresensi } from './profil/detail_presensi/page';
export { NewsPage } from './home/news/page';
export { NotifikasiPage } from './notifikasi/page';


// WEBPACK FOOTER //
// ./src/pages/dashboard/index.ts